import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Loading from './Loading';
import { isAdmin } from '../utils/adminConfig';

const PrivateRoute = ({ children, adminOnly = false }) => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <Loading />;
  }

  if (!currentUser) {
    // Save the attempted URL to redirect back after login
    return <Navigate to="/login" state={{ from: location.pathname }} />;
  }

  // Check if admin access is required and user is not the designated admin
  if (adminOnly && !isAdmin(currentUser)) {
    // Redirect to unauthorized page or home
    return <Navigate to="/" />;
  }

  return children;
};

export default PrivateRoute; 